import Pane, { IPaneConfig } from './pane';

export interface IWidgetPaneConfig extends IPaneConfig {
}

export default class Widget extends Pane {
}



// WEBPACK FOOTER //
// ./lib/engine/core/panes/widgetsCore.ts